import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { getLegacyAccountSubscription } from '../api';
import type { Account, LegacySubscription } from '../model';

import { useAccountQuery } from './useAccountQuery';

export function useLegacySubscription(account: Account | null | undefined) {
  return useAccountQuery<LegacySubscription | null, RequestError>(
    account
      ? (queryKeys.accounts.legacySubscription(account._id) as readonly unknown[])
      : ['accounts', 'legacy-subscription', null],
    ({ signal }) =>
      account ? observableToPromise(getLegacyAccountSubscription(account), signal) : Promise.resolve(null),
    account,
  );
}
